module.exports = __webpack_public_path__ + "static/media/K2.a20046ef.png";